var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("dl", { staticClass: "boss-scoutandlike-item-list-item" }, [
    _c(
      "dt",
      {
        staticClass:
          "boss-scoutandlike-item-list-head boss-scoutandlike-item-list-recommend",
        class: { "boss-new": _vm.hasUnread },
        attrs: { "data-alignment": "center" },
      },
      [
        _c("div", { staticClass: "boss-scoutandlike-item-list-title" }, [
          _c("span", { staticClass: "boss-icon", class: _vm.iconName }),
          _vm._v(" "),
          _c("span", [
            _vm._v(_vm._s(_vm.title) + "\n        "),
            _vm.tooltip
              ? _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: { content: _vm.tooltip },
                        expression: "{ content: tooltip}",
                      },
                    ],
                    staticClass: "pega-circle",
                  },
                  [_vm._v("?\n        ")]
                )
              : _vm._e(),
          ]),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "dd",
      {
        staticClass: "boss-scoutandlike-item-list-body",
        class: { tall: _vm.isTall },
      },
      [
        _c(
          "div",
          { staticClass: "boss-scoutandlike-item-list-text" },
          [_vm._t("default")],
          2
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }